import { EIntakeStep } from "@rentiohq/shared-frontend/dist/types/application.types";
import { EIntakeType } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getStepsForIntakeType } from "utils/application.utils";
import { EPropertyApplicationsCustom } from "./PropertyDetailApplications.types";

export const getSteps = (
  intakeType: EIntakeType,
  hasCalendarSync?: boolean,
  hasRentMatch?: boolean,
) => {
  return getStepsForIntakeType(intakeType).reduce(
    (allSteps, steps: EIntakeStep[]) => {
      const eligibleSteps = steps.filter(step => {
        if (step === EIntakeStep.notEligible) return false;
        // "Invited" applies to brokers who invite via calendar sync or RentMatch.
        // Only hide it when neither feature is active; a broker with just one of
        // the two still needs the "Invited" option. (Previously two separate OR
        // checks hid it whenever a single flag was off, so it went missing in the
        // properties overview filter.)
        if (
          step === EIntakeStep.invited &&
          hasCalendarSync === false &&
          hasRentMatch === false
        )
          return false;
        return true;
      });
      return [...allSteps, eligibleSteps];
    },
    [] as EIntakeStep[][],
  );
};

export const mappedApplications: any = {
  [EIntakeStep.candidateVisitor]: EPropertyApplicationsCustom.CandidateVisitors,
  [EIntakeStep.invited]: EPropertyApplicationsCustom.Invited,
  [EIntakeStep.candidateTenant]: EPropertyApplicationsCustom.CandidateTenants,
  [EIntakeStep.tenant]: EPropertyApplicationsCustom.Tenant,
  [EIntakeStep.notEligible]: EPropertyApplicationsCustom.NotEligible,
  [EIntakeStep.visitor]: EPropertyApplicationsCustom.Visitors,
  [EIntakeStep.planAsVisitor]: EPropertyApplicationsCustom.ScheduleForVisit,
  [EIntakeStep.waitingList]: EPropertyApplicationsCustom.WaitingList,
};

export const getApplicationsFilterOptions = (
  intakeType: EIntakeType = 2,
  hasCalendarSync?: boolean,
  hasRentMatch?: boolean,
) => {
  const steps = getSteps(intakeType, hasCalendarSync, hasRentMatch);
  const flatStepsList = [...new Set((steps || []).flat())];
  return [
    EPropertyApplicationsCustom.All,
    EPropertyApplicationsCustom.WithApplications,
    ...flatStepsList.map(step => mappedApplications[step]).filter(Boolean),
    EPropertyApplicationsCustom.Archived,
    EPropertyApplicationsCustom.NotEligible,
  ];
};
